import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { authApi } from '../../services/api';
import './Auth.css';

const VerifyEmailPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('E-posta adresiniz doğrulanıyor, lütfen bekleyiniz...');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Doğrulama belirteci bulunamadı.');
      return;
    }

    const verify = async () => {
      try {
        const res = await authApi.verifyEmail(token);
        if (res.success) {
          setStatus('success');
          setMessage(res.message || 'E-posta adresiniz başarıyla doğrulandı!');
        }
      } catch (err: any) {
        setStatus('error');
        setMessage(err.response?.data?.message || 'Doğrulama bağlantısı geçersiz veya süresi dolmuş.');
      }
    };

    verify();
  }, [token]);

  return (
    <div className="auth-container">
      <div className="auth-card" style={{ maxWidth: '480px' }}>
        <div className="verification-status-box" style={{ textAlign: 'center' }}>
          {status === 'loading' && (
            <>
              <div className="status-spinner" style={{ margin: '0 auto 15px auto' }}></div>
              <h2 style={{ fontSize: '20px', color: '#0f172a', marginBottom: '8px' }}>Doğrulanıyor...</h2>
              <p style={{ color: '#64748b', fontSize: '14px' }}>{message}</p>
            </>
          )}

          {status === 'success' && (
            <div style={{ textAlign: 'left' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#16a34a', marginBottom: '12px', fontWeight: 700, fontSize: '18px' }}>
                <span style={{ fontSize: '24px' }}>🎉</span>
                <span>Tebrikler! Hesabınız Doğrulandı</span>
              </div>
              
              <p style={{ margin: '0 0 16px 0', fontSize: '14px', color: '#334155', lineHeight: 1.5 }}>
                {message}
              </p>

              {/* Kılavuz Bilgi Kartı */}
              <div style={{
                background: '#eff6ff',
                border: '1px solid #bfdbfe',
                borderRadius: '10px',
                padding: '14px 16px',
                marginBottom: '20px'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#1e40af', fontWeight: 700, fontSize: '13px', marginBottom: '6px' }}>
                  <span>📩</span>
                  <span>10 Adımlı Kullanım Kılavuzunuz Gönderildi</span>
                </div>
                <p style={{ margin: 0, fontSize: '12px', color: '#1e3a8a', lineHeight: 1.5 }}>
                  Sistemi ilk andan itibaren kolayca yönetebilmeniz için <strong>10 adımlı rehberinizi</strong> e-posta adresinize gönderdik. Sisteme giriş yaptığınızda ekranın sağ tarafındaki <strong>interaktif rehber kutusundan</strong> da adımları sırayla takip edip tamamlayabilirsiniz.
                </p>
              </div>

              <button
                className="auth-btn-primary"
                onClick={() => navigate('/login')}
                style={{ width: '100%', padding: '12px 20px', fontSize: '14px', fontWeight: 700, borderRadius: '8px' }}
              >
                🚀 Giriş Yap ve Kılavuzu Başlat
              </button>

              <div style={{ textAlign: 'center', marginTop: '16px' }}>
                <a
                  href="https://wa.me/905072136474?text=Merhaba,%20Uzman%20Destek%20sistemine%20yeni%20kay%C4%B1t%20oldum,%20kurulum%20ve%20kullan%C4%B1mda%20yard%C4%B1m%20alabilir%20miyim?"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                    color: '#15803d',
                    textDecoration: 'none',
                    fontSize: '13px',
                    fontWeight: 600
                  }}
                >
                  <span>💬</span>
                  <span>Canlı Destek: 0507 213 64 74 (WhatsApp)</span>
                </a>
              </div>
            </div>
          )}

          {status === 'error' && (
            <>
              <div className="status-icon error" style={{ margin: '0 auto 12px auto' }}>⚠️</div>
              <h2 style={{ fontSize: '18px', color: '#dc2626', marginBottom: '8px' }}>Doğrulama Başarısız</h2>
              <p style={{ color: '#475569', fontSize: '13px', marginBottom: '20px' }}>{message}</p>
              <button
                className="auth-btn-primary"
                onClick={() => navigate('/login')}
                style={{ width: '100%' }}
              >
                Giriş Sayfasına Dön
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
